<div class="body-slider" [ngStyle]="{'width': ws, 'height': hs}">

  <ng-container [ngSwitch]="type">

    <ng-container *ngSwitchCase="'all'">
      <span class="all"><img [src]="'../../../../../assets/' + slide.img" alt=""></span>
      <span *ngIf="slide.info" class="info" [textContent]="slide.info | transloco"></span>
      <span class="all discription">{{slide.discription | transloco}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'img'">
      <span class="img"><img [src]="'../../../../../assets/' + slide.img" alt=""></span>
    </ng-container>

    <ng-container *ngSwitchCase="'product'">
      <ng-container *ngIf="slide.img else products">
        <span class="all"><img [src]="'../../../../../assets/' + slide.img" alt=""></span>
        <span class="all discription">{{slide.discription | transloco}}</span>
      </ng-container>
      <ng-template #products>
        <bz-product (onEventsProduct)="onEventsProduct($event)" [BzProduct]="slide.product"></bz-product>
      </ng-template>
    </ng-container>

  </ng-container>

</div>
